import {
  ISuburbanOfferFilter,
  ISuburbanOfferFilterAction,
  TSuburbanOfferFilter,
} from '../../../models/filters/suburban_offer_filter';

export const SUBURBAN_OFFER_FILTER_UPDATE = 'search/SUBURBAN_OFFER_FILTER_UPDATE';

const initialState: ISuburbanOfferFilter = {
  suburbanOfferFilter: 'all',
  isDirty: false,
};

const defaultAction: ISuburbanOfferFilterAction = {
  type: SUBURBAN_OFFER_FILTER_UPDATE,
  payload: {},
};

export const suburbanOfferFilterReducer = (state = initialState, action = defaultAction) => {
  switch (action.type) {
    case SUBURBAN_OFFER_FILTER_UPDATE:
      const newState = Object.assign({}, state, action.payload);
      if (!newState.isDirty) {
        newState.suburbanOfferFilter = 'all';
      }

      return newState;
    default:
      return state;
  }
};

export const setSuburbanOfferFilter = (
  suburbanOfferFilter: TSuburbanOfferFilter = 'all',
): ISuburbanOfferFilterAction => {
  return {
    type: SUBURBAN_OFFER_FILTER_UPDATE,
    payload: {
      suburbanOfferFilter,
    },
  };
};

export const setSuburbanOfferFilterDirty = (isDirty: boolean): ISuburbanOfferFilterAction => {
  return {
    type: SUBURBAN_OFFER_FILTER_UPDATE,
    payload: {
      isDirty,
    },
  };
};
